export const ADD_TO_PLAN = 'App/Calendar::ADD_TO_PLAN';
export const REMOVE_FROM_PLAN = 'App/Calendar::REMOVE_FROM_PLAN';
export const API_GET_CALENDAR = 'App/Api::API_GET_CALENDAR';
export const CALENDAR_WEEK_NUMBER = 'App/Calendar::CALENDAR_WEEK_NUMBER';
